var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelparrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.91,
    height: 7.247,
    viewBox: "0 0 12.91 7.247",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27793",
    "data-name": "Group 27793",
    transform: "translate(-24 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_12_",
    "data-name": "download (12)",
    transform: "translate(24 33.247) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32011",
    "data-name": "Path 32011",
    d: "M7.015,7.035,1.372,12.678a.817.817,0,0,1-1.14,0,.817.817,0,0,1,0-1.14L5.315,6.455.232,1.372a.817.817,0,0,1,0-1.14.817.817,0,0,1,1.14,0L7.015,5.895A.817.817,0,0,1,7.015,7.035Z",
    fill: "#208ce1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelparrow2);
export default __webpack_public_path__ + "static/media/helparrow2.93d780399265b3c99409b01adbf5306e.svg";
export { ForwardRef as ReactComponent };